<template>
  <main class="plan-change settings">
    <app-loading v-if="isLoading"></app-loading>
    <div v-else>
      <section class="label-link-area">
        <h2 class="label-link-area__ttl">プランを変更する</h2>
        <div class="label-link-area__main">
          <section class="credits-info" v-if="!noAvailableCredits">
            <div class="credits-info__inner">
              <!-- <h3 class="credits-info__ttl">{{creditsBrands[creditInfo.cardbrand_code]}} {{creditInfo.cc_number}}</h3> -->
              <h3 class="credits-info__ttl">{{creditInfo.cc_number}}</h3>
              <p class="credits-info__sentence">{{creditInfo.cc_expiration | creditDateFormat}}</p>
              <div class="credits-info__btns">
                <a class="grey-btn" @click="editCredit()">編集</a>
                <a class="grey-btn" @click="deleteCredit()">削除</a>
              </div>
            </div>
          </section>
          <section v-else class="no-credits-information">
            <h2 class="no-credits-information__ttl">クレジットカード情報を入力してください</h2>
            <router-link :to="{ name: 'settingCreditCard', params: { method: 'register' }}" class="btn">
              情報入力画面へ
            </router-link>
          </section>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
  import Loading from '../common/Loading.vue';
  import { creditsBrands } from '../../constants';

  export default {
    title: 'クレジットカード - abceed',
    headerTitle: 'クレジットカード',
    description: '',
    keywords: '',
    headerType: 'historyBackNotSearch',
    components: {
      appLoading: Loading
    },
    data() {
      return {
        noAvailableCredits: false,
      }
    },
    beforeCreate() {
      this.$store.dispatch("changeLoadingCondition", true);
    },
    created() {
      this.$store.dispatch('getCreditsInfo')
        .then(data => {
          if (data.message === 'Not found credit card.') {
            this.noAvailableCredits = true;
          } else {
            this.noAvailableCredits = false;
          }
          this.$store.dispatch("changeLoadingCondition", false);
        }).catch(() => {
          //リトライボタンの表示
          this.$store.dispatch("changeLoadingCondition", false);
        });
    },
    computed: {
      isLoading() {
        return this.$store.getters.isLoading;
      },
      creditInfo() {
        return this.$store.getters.creditInfo;
      }
    },
    methods: {
      deleteCredit() {
        if (!confirm('クレジットカード情報を削除してもよろしいですか？')) {
          return
        }
        this.$store.dispatch("changeLoadingCondition", true);
        this.$store.dispatch('deleteCreditsInfo', {})
          .then(data => {
            this.$store.dispatch("changeLoadingCondition", false);
            if (data.result === 'success') {
              alert("クレジットカード情報を削除しました。");
              this.noAvailableCredits = true;
            } else {
              alert("クレジットカード情報の削除に失敗しました。");
            }
          })
          .catch(err => {
            alert("クレジットカード情報の削除に失敗しました。");
            this.$store.dispatch("changeLoadingCondition", false);
          });
      },
      editCredit() {
        this.$router.push({ name: 'settingCreditCard', params: { method: 'edit' }});
      }
    }
  }
</script>

<style scoped lang="scss">
.no-credits-information {
  padding: 20px 0;
  &__ttl {
    font-weight: bold;
    font-size: 16px;
    font-size: 1.6rem;
    margin-bottom: 10px;
  }
  .btn {
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/settings/Credit.vue